import type { IExercise } from "store/slices/exercise";

import { saveToTimedLocalStorage, getFromTimedLocalStorage } from "utils/localStorage";

import { ONBOARDING_STORE_ID, SESSION_STORAGE_KEY } from "const";
import { encodeEmail } from "utils/common/common";

export interface ISessionSavedInStorage extends IExercise {
  spentTime: number;
}

export const saveSessionToStorage = (data: ISessionSavedInStorage, email: string | undefined | null) => {
  if (typeof email !== "string") return;

  const expiration = new Date();
  expiration.setDate(expiration.getDate() + 1);
  expiration.setHours(2, 0, 0, 0);

  const key = encodeEmail(SESSION_STORAGE_KEY, email);
  saveToTimedLocalStorage(key, JSON.stringify(data), expiration.getTime());
};

export const getSessionFromStorage = (email: string | undefined | null) => {
  if (typeof email !== "string") return null;

  const key = encodeEmail(SESSION_STORAGE_KEY, email);
  const dataString = getFromTimedLocalStorage(key);

  if (dataString === null) return null;

  const data = JSON.parse(dataString) as ISessionSavedInStorage;

  // AIDEV-NOTE: Pojistka pro studenty, kterým starší verze uložila zástupnou session
  // onboardingu. `Intro` by na ni přesměroval (/cviceni/onboarding), backend ji nezná
  // a odpovědi by padaly až do vypršení záznamu. [TD-455]
  if (data.sessionId === ONBOARDING_STORE_ID) {
    window.localStorage.removeItem(key);
    return null;
  }

  return data;
};

export const removeSessionFromStorage = (email: string | undefined | null) => {
  if (typeof email !== "string") return null;

  const key = encodeEmail(SESSION_STORAGE_KEY, email);
  window.localStorage.removeItem(key);
};
